import React from "react";
import "./mapWidget.scss";
import { withStyles } from "@material-ui/core/styles";
import {
  Select,
  MenuItem,
  Switch,
  TextField,
  IconButton,
  Tooltip,
  Typography,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import AddIcon from "@material-ui/icons/Add";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

import Autocomplete from "@material-ui/lab/Autocomplete";
import parse from "autosuggest-highlight/parse";

import MapGL, { Marker, Source, Layer } from "react-map-gl";
import Property from "./components/Property";
import AdjustForm from "./components/AdjustForm";
import Routing from "./components/Routing";
import Pagination from "@material-ui/lab/Pagination";
import {
  makeGeoJsonData,
  dataLayer,
  loadIntialDataAsync,
  getStaticUrl,
  getMapUrl,
  searchAddress,
  symboldataLayer,
  loadGeoJsonAsync,
  getDirectionAsync,
} from "./services/mapTile";
import { styles } from "./mapWIdget.style";
import html2canvas from "html2canvas";

class MapWidget extends React.Component {
  mapWidget = null;
  isEventRegisted = false;
  constructor(props) {
    super(props);
    const { mainProperty, settings } = props;
    const { latitude, longitude, data, iconUrl } = mainProperty;

    const isColapsed = settings.isColapsedLeftPanel
      ? settings.isColapsedLeftPanel
      : false;
    settings.useDefaultGeolocation =
      settings.useDefaultGeolocation === undefined ||
      settings.useDefaultGeolocation === null
        ? true
        : settings.useDefaultGeolocation;

    const layout = !isColapsed
      ? {
          xs: 5,
          md: 3,
          sm: 3,
          isColapsed,
        }
      : {
          xs: 0,
          md: 0,
          sm: 0,
          isColapsed,
        };
    const zoom = settings.zoom ? settings.zoom : 12;
    this.state = {
      viewport: {
        latitude: settings.centerViewport.latitude,
        longitude: settings.centerViewport.longitude,
        zoom: zoom,
        bearing: 0,
        pitch: 0,
        attributionControl: false,
      },
      marker: {
        latitude,
        longitude,
        iconUrl: iconUrl ? iconUrl : getStaticUrl("images/markers/green.png"),
      },
      maptype: null,
      mapSearch: {
        enable: false,
        value: "",
      },
      events: {},
      options: [],
      features: [
        //{ name: 'Nhập tọa độ', value: 1 },
      ],
      selectedFeature: 0,
      menuFeatureEl: null,
      mainProperty,
      maptiles: [],
      formValues: {
        x: "",
        y: "",
        longitude: "",
        latitude: "",
        data,
        provinceValue: 21, //ho chi minh
        tracking: false,
        isError: false,
        errorMessage: "This is an error message!",
        isDeleteDialogOpen: false,
        deleteItem: null,
        iconUrl: getStaticUrl("images/markers/mainMarker.png"),
        anchorEl: null,
        menuSelected: null,
      },
      container: {
        width: 0,
        height: 0,
      },
      layout,
      settings,
      geoJson: null,
      geoLablesJson: null,
      isSearching: false,
      searchText: "",
      routings: null,
    };

    this.container = React.createRef();
    setTimeout(() => {
      this._checkContainerResize();
    }, 100);
  }

  handleResize = () => {
    this._checkContainerResize();
  };

  async componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);

    setTimeout(async () => {
      await this._fetchMaptilesData();
    }, 100);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  notifyUpdateValues = (marker, formValues) => {
    const { onUpdateValues } = this.props;
    if (onUpdateValues) {
      const { data } = formValues;
      const { longitude, latitude } = marker;
      onUpdateValues({
        longitude,
        latitude,
        data,
      });
    }
  };

  _registerMapEvent = (map) => {
    if (!this.isEventRegisted) {
      this.isEventRegisted = true;
      const { onIdle } = this.props;
      if (onIdle) {
        map.on("idle", () => {
          onIdle();
        });
      }
    }
  };

  _updateViewport = (viewport) => {
    const { onCenterPointChanged } = this.props;
    if (onCenterPointChanged) {
      onCenterPointChanged(viewport.longitude, viewport.latitude);
    }
    this.setState({ viewport });
  };

  _logDragEvent(name, event) {
    const { lngLat } = event;
    const { marker } = this.state;
    this.setState({
      marker: {
        ...marker,
        longitude: lngLat[0],
        latitude: lngLat[1],
      },
      events: {
        ...this.state.events,
        [name]: lngLat,
      },
    });
  }

  _onMarkerDragStart = (event) => {
    this._logDragEvent("onDragStart", event);
  };

  _onMarkerDrag = (event) => {
    this._logDragEvent("onDrag", event);
  };

  _onMarkerDragEnd = (event) => {
    this._logDragEvent("onDragEnd", event);
    const { lngLat } = event;
    this._setMapLocation(lngLat[0], lngLat[1]);
  };

  _onSelectAddress = (address) => {
    if (!address) return;

    const { latitude, longitude } = address;

    if (!latitude || !longitude) return;

    this._setMapLocation(longitude, latitude, true);
  };

  _onMapClick = (event) => {
    const self = this;
    if (self.state.events.preventClick) {
      this.setState({
        events: {
          ...self.state.events,
          preventClick: false,
        },
      });
    }

    if (event.leftButton) {
      const { lngLat } = event;
      this._setMapLocation(lngLat[0], lngLat[1]);
    }
  };

  _setMapLocation = (longitude, latitude, setCenter = false) => {
    const self = this;
    const { viewport, formValues, marker } = self.state;
    if (setCenter) {
      viewport.longitude = longitude;
      viewport.latitude = latitude;
    }
    const newMarker = {
      ...marker,
      longitude,
      latitude,
      className: "marker-transision",
    };
    self.setState({
      marker: {
        ...marker,
        ...newMarker,
      },
      viewport,
    });

    self.notifyUpdateValues(newMarker, formValues);

    setTimeout(function () {
      self.setState({
        viewport: viewport,
        marker: {
          ...marker,
          longitude,
          latitude,
          className: "",
        },
      });
    }, 300);
  };

  _stopPropagation = (event) => {
    if (event.nativeEvent) {
      event.nativeEvent.preventDefault();
      event.nativeEvent.stopPropagation();
    }
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    const self = this;
    this.setState({
      events: {
        ...self.state.events,
        preventClick: true,
      },
    });

    return false;
  };

  // Change map type
  _onSelectChanged = async (event) => {
    const { value } = event.target;
    const { accessToken } = this.props;
    const data = await loadGeoJsonAsync(accessToken, value);
    const { featureCollection, featureLablesCollection } =
      makeGeoJsonData(data);

    this.setState({
      geoJson: featureCollection,
      geoLablesJson: featureLablesCollection,
      maptype: {
        select: value,
        url: getMapUrl(value),
      },
    });
  };

  _onSwitchChanged = (event) => {
    const { mapSearch } = this.state;
    this.setState({
      mapSearch: {
        ...mapSearch,
        enable: !mapSearch.enable,
      },
    });
  };

  _onSetCurrentLocation = (event) => {
    const self = this;
    let location = null;
    if (window.navigator && window.navigator.geolocation) {
      location = window.navigator.geolocation;
    }
    if (location) {
      const { formValues } = self.state;
      location.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        const marker = {
          ...self.state.marker,
          longitude: longitude,
          latitude: latitude,
        };
        self.setState({
          viewport: {
            ...self.state.viewport,
            latitude: latitude,
            longitude: longitude,
            zoom: self.state.viewport.zoom ? self.state.viewport.zoom : 12,
          },
          marker,
        });

        self.notifyUpdateValues(marker, formValues);
      });
    } else {
      alert("Browser is not support get location !");
    }
  };

  _fetchMaptilesData = async () => {
    const { accessToken, memberId } = this.props;
    const { settings } = this.state;
    const getDefaultMap = () => {
      let defaultMap = settings.defaultMap;
      if (defaultMap && maptiles.some((m) => m.id === defaultMap)) {
        return defaultMap;
      }
      return maptiles[0].id;
    };

    const { data, maptiles } = await loadIntialDataAsync(
      accessToken,
      memberId,
      settings.defaultMap
    );
    const selectedMap = maptiles.length > 0 ? getDefaultMap() : "";
    const { featureCollection, featureLablesCollection } =
      makeGeoJsonData(data);
    this.setState({
      geoJson: featureCollection,
      geoLablesJson: featureLablesCollection,
      maptiles,
      maptype: {
        select: selectedMap,
        url: getMapUrl(selectedMap),
      },
    });
  };

  _searchIndex = (str, searchValue, isCaseSensitive) => {
    var modifiers = isCaseSensitive ? "gi" : "g";
    var regExpValue = new RegExp(searchValue, modifiers);
    var matches = [];
    var startIndex = 0;
    var arr = str.match(regExpValue);
    if (!arr) return [];

    arr.forEach((element) => {
      startIndex = str.indexOf(element, startIndex);

      matches.push({
        offset: startIndex++,
        length: element.length + 1,
      });
    });

    return matches;
  };

  _handleChange = (event) => {
    const self = this;
    const inputValue = event.target.value;
    const { accessToken } = this.props;

    self.setState({ isSearching: true, searchText: inputValue, options: [] });
    searchAddress(accessToken, inputValue, (results) => {
      const options =
        results.map((item) => {
          const { address } = item;
          const terms = inputValue.split(" ");
          let matches = [];
          terms.forEach((term) => {
            if (term) {
              matches = [...matches, ...self._searchIndex(address, term, true)];
            }
          });
          item.matches = matches;
          return item;
        }) || [];

      self.setState({
        isSearching: false,
        options,
      });
    });
  };

  _handleFeaturesClick = (action) => {
    const { onActionClick } = this.props;
    if (onActionClick) {
      onActionClick(action);
    }
  };

  _setColapseForm = (isColapsed) => {
    const { layout } = this.state;
    if (!isColapsed) {
      this.setState({
        layout: {
          ...layout,
          xs: 5,
          md: 3,
          sm: 3,
          isColapsed,
        },
      });
    } else {
      this.setState({
        layout: {
          ...layout,
          xs: 0,
          md: 0,
          sm: 0,
          isColapsed,
        },
      });
    }

    setTimeout(() => {
      this._checkContainerResize();
      setTimeout(() => {
        this._forceUpdate();
      }, 250);
    }, 250);
  };

  _onFormValuseToggle = (value) => {
    const { layout } = this.state;
    const { isColapsed } = layout;

    this._setColapseForm(!isColapsed);
  };

  _onUpdateFormValues = (formValues) => {
    const { marker } = this.state;
    this.notifyUpdateValues(marker, formValues);
    this._forceUpdate();
  };
  _onPageChanged = (event, page) => {
    this._stopPropagation(event);
    const { onPageIndexChanged } = this.props;
    if (onPageIndexChanged) {
      onPageIndexChanged(page);
    }

    this._forceUpdate();
  };

  _renderActions = (action) => {
    return (
      <div
        className={"form-control map-current-position action-key-" + action.key}
        key={action.key}
      >
        <Tooltip title={action.name} placement="bottom">
          <IconButton
            aria-label="more"
            aria-controls="long-menu"
            aria-haspopup="true"
            onClick={() => this._handleFeaturesClick(action)}
          >
            <img alt="" src={action.iconUrl}></img>
          </IconButton>
        </Tooltip>
      </div>
    );
  };

  _checkContainerResize = () => {
    if (this.container && this.container.current) {
      const { offsetWidth, offsetHeight } = this.container.current;
      const { container } = this.state;
      const { width, height } = container;
      if (width !== offsetWidth || height !== offsetHeight) {
        // Resize
        this.setState({
          container: {
            ...container,
            width: offsetWidth,
            height: offsetHeight,
          },
        });
        return;
      }
    }
  };

  _forceUpdate = () => {
    this.setState({ state: this.state });
  };

  setRoutings = (routings) => {
    this.setState({ routings });
  };

  setMainProperty = (mainProperty) => {
    const { latitude, longitude, data, iconUrl } = mainProperty;
    const { marker, formValues } = this.state;
    this.setState({
      marker: {
        ...marker,
        longitude: longitude,
        latitude: latitude,
        iconUrl: iconUrl ? iconUrl : getStaticUrl("images/markers/green.png"),
      },
      formValues: {
        ...formValues,
        data: data ? data : [],
      },
    });
  };

  setCenterView = (longitude, latitude, updateCenterPoint = false) => {
    if (updateCenterPoint) {
      this._setMapLocation(longitude, latitude, true);
    } else {
      const { viewport } = this.state;
      viewport.longitude = longitude;
      viewport.latitude = latitude;
      this._updateViewport(viewport);
    }
  };

  setZoom = (zoom) => {
    const isZoomValid = zoom && zoom > 0 && zoom < 30;
    if (isZoomValid) {
      const { viewport } = this.state;
      viewport.zoom = zoom;
      this._updateViewport(viewport);
    } else {
      console.warn("zoom value is invalid !", zoom);
    }
  };

  takePicture = (config) => {
    return new Promise((resolve, reject) => {
      const element = document.getElementsByClassName(
        "map-widget-container"
      )[0];
      if (element) {
        html2canvas(element, {
          logging: false,
          letterRendering: 1,
          useCORS: true,
        }).then(function (canvas) {
          var imgSrc = canvas.toDataURL();
          resolve(imgSrc);
        });
      }
    });
  };

  getDirectionAsync = async (profile, start, end) => {
    const { accessToken } = this.props;
    const data = await getDirectionAsync(accessToken, profile, start, end);
    return data;
  };

  render() {
    const {
      viewport,
      marker,
      mapSearch,
      maptype,
      options,
      layout,
      formValues,
      geoJson,
      geoLablesJson,
      container,
      maptiles,
      isSearching,
      searchText,
      routings,
    } = this.state;

    const {
      classes,
      properties,
      pagination,
      settings,
      actions,
      accessToken,
      memberId,
    } = this.props;

    let mapxs = 12;
    let mapsm = 12;
    let mapmd = 12;
    if (settings.useVn2000) {
      mapxs = 12 - layout.xs;
      mapsm = 12 - layout.sm;
      mapmd = 12 - layout.md;
    }

    this._checkContainerResize();

    const transformRequest = (url, resourceType) => {
      return {
        url: url,
        headers: {
          Authorization: "Bearer " + accessToken,
          ClientId: memberId,
        },
      };
    };

    return (
      <div className="home-container map-widget-container">
        <Grid className={classes.fullHeight} container>
          {settings.useVn2000 ? (
            layout.isColapsed ? (
              <div className={classes.enableFormValues}>
                <IconButton
                  aria-label="settings"
                  onClick={this._onFormValuseToggle}
                >
                  <ChevronRightIcon />
                </IconButton>
              </div>
            ) : (
              <AdjustForm
                layout={layout}
                marker={marker}
                formValues={formValues}
                onColapsed={this._onFormValuseToggle}
                onUpdateValues={this._onUpdateFormValues}
                onSetLocation={(longitude, latitude) =>
                  this._setMapLocation(longitude, latitude, true)
                }
              ></AdjustForm>
            )
          ) : null}

          <Grid
            container
            item
            ref={this.container}
            xs={mapxs}
            sm={mapsm}
            md={mapmd}
            spacing={0}
          >
            {mapSearch.enable ? (
              <div
                style={{ width: container.width }}
                className="search-box"
                onClick={this._stopPropagation}
              >
                <Autocomplete
                  getOptionLabel={(option) => {
                    return option.address ? option.address : searchText;
                  }}
                  filterOptions={(x) => x}
                  loading={false}
                  options={options}
                  onChange={(event, newValue) => {
                    this._onSelectAddress(newValue);
                  }}
                  renderInput={(params) => (
                    <span>
                      <TextField
                        {...params}
                        label="Tìm kiếm địa chỉ (Enter)"
                        value={{ searchText }}
                        variant="outlined"
                        fullWidth
                        noOptionsText="Chưa có kết quả"
                        onKeyDown={(e) => {
                          if (e.key === "Enter" && e.target.value) {
                            this._handleChange(e);
                          }
                        }}
                      />
                      {isSearching ? (
                        <CircularProgress className="autoCompleteWaiting" />
                      ) : null}
                    </span>
                  )}
                  renderOption={(option) => {
                    const { matches } = option;
                    const parts = parse(
                      option.address,
                      matches.map((match) => [
                        match.offset,
                        match.offset + match.length,
                      ])
                    );
                    return (
                      <Grid container alignItems="center">
                        <Grid item>
                          <LocationOnIcon className={classes.icon} />
                        </Grid>
                        <Grid item xs>
                          {parts.map((part, index) => (
                            <span
                              key={index}
                              style={{
                                fontWeight: part.highlight ? 700 : 400,
                              }}
                            >
                              {part.text}
                            </span>
                          ))}

                          <Typography variant="body2" color="textSecondary">
                            {option.subAddress}
                          </Typography>
                        </Grid>
                      </Grid>
                    );
                  }}
                />
              </div>
            ) : null}

            {settings.useMenu ? (
              <div className="options" onClick={this._stopPropagation}>
                <div className="form-control maptypes">
                  {maptype != null ? (
                    <Select
                      value={maptype.select}
                      onChange={this._onSelectChanged}
                    >
                      {maptiles.map((tile) => {
                        return (
                          <MenuItem key={tile.id} value={tile.id}>
                            {tile.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  ) : null}
                </div>
                <div className="form-control mapsearch-onoff">
                  <Tooltip title="Tìm kiếm" placement="bottom">
                    <Switch
                      checked={mapSearch.enable}
                      onClick={this._onSwitchChanged}
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </Tooltip>
                </div>

                {settings.useDefaultGeolocation ? (
                  <div className="form-control map-current-position">
                    <Tooltip title="Định vị" placement="bottom">
                      <IconButton
                        color="primary"
                        aria-label="add"
                        size="small"
                        onClick={this._onSetCurrentLocation}
                      >
                        <AddIcon />
                      </IconButton>
                    </Tooltip>
                  </div>
                ) : null}

                {actions ? actions.map(this._renderActions) : null}
              </div>
            ) : null}

            {settings.usePaging && pagination ? (
              <div
                style={{ width: container.width, top: container.height - 10 }}
                className={classes.paginationContainer}
              >
                <Pagination
                  className={classes.pagination}
                  count={pagination.pages}
                  page={pagination.index}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  onChange={this._onPageChanged}
                />
              </div>
            ) : null}
            {/* ==========================MAP========================== */}
            {maptype != null ? (
              <MapGL
                {...viewport}
                width="100%"
                height="100%"
                mapStyle={maptype.url}
                onViewportChange={this._updateViewport}
                mapboxApiAccessToken="nothings"
                onClick={this._onMapClick}
                transformRequest={transformRequest}
                preserveDrawingBuffer={true}
                reuseMaps={true}
                ref={(instance) => {
                  if (this.mapWidget === null) {
                    this.mapWidget = instance;
                  }
                }}
                onLoad={(evt) => {
                  const map = evt.target;
                  this._registerMapEvent(map);
                }}
              >
                {settings.useCenterPoint ? (
                  <Marker
                    longitude={marker.longitude}
                    latitude={marker.latitude}
                    className={classes.marker}
                    width="50"
                    height="50"
                    offsetTop={-50}
                    offsetLeft={-10}
                    captureClick={true}
                    draggable
                    onDragStart={this._onMarkerDragStart}
                    onDrag={this._onMarkerDrag}
                    onDragEnd={this._onMarkerDragEnd}
                  >
                    <div className="custom-marker grow">
                      <img
                        src={marker.iconUrl}
                        className="leaflet-marker-icon "
                        alt=""
                      />
                    </div>
                  </Marker>
                ) : null}

                <Source type="geojson" data={geoJson}>
                  <Layer {...dataLayer} />
                </Source>
                <Source type="geojson" data={geoLablesJson}>
                  <Layer {...symboldataLayer} />
                </Source>

                {/* ==========================ROUTINGS========================== */}
                {routings
                  ? routings.map((data, idx) => (
                      <Routing key={idx} data={data}></Routing>
                    ))
                  : null}

                {properties
                  ? properties.map((property) => {
                      return (
                        <Property
                          key={property.id}
                          longitude={property.longitude}
                          latitude={property.latitude}
                          data={property.data}
                          iconUrl={property.iconUrl}
                          isShowPopup={true}
                          showMarker={property.showMarker}
                          toolTip={property.toolTip}
                        ></Property>
                      );
                    })
                  : null}

                {!!formValues ? (
                  <Property
                    showMarker={false}
                    longitude={marker.longitude}
                    latitude={marker.latitude}
                    data={formValues.data}
                    iconUrl={formValues.iconUrl}
                  ></Property>
                ) : null}
              </MapGL>
            ) : (
              <div className={classes.mapWaiting}>
                <CircularProgress disableShrink />
              </div>
            )}
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(MapWidget);
